module.exports = __webpack_public_path__ + "img/LR.d3e2207a.svg";